import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FiEye, FiInfo } from "react-icons/fi";
import {
  allTrainingFilter,
  getTrainingManagementStatusClass,
  TM_STATUS,
  TRAINING_PROGRESS_CHECK,
} from "../CONSTANTS";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { ACTIVE_MODULE } from "app/_constants/constant";
// import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import FormField from "app/Components/Form/FormField.component";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { isUserVTO } from "../../IncidentManagement/Helper";
import {
  TRAINING_STATUS,
  TRAINEE_TYPE,
  TRAINING_STATUS_VIEW,
  trainingStatusFilterFields,
} from "../CONSTANTS";
import {
  getAllTrainingAssigners,
  getAllTrainingAssignersData,
} from "app/_services/ehs/ehsTrainingServices";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import { useForm } from "app/_helpers/hooks";
import TrainingStatusFilters from "../Assign/Component/TrainingStatusFilters";
import { validateRowFilter } from "../../IncidentManagement/CONSTANTS";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { downloadFileByExistURL, downloadFileByURL } from "app/_helpers/reactHelper";
import { capitalize } from "lodash";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import { useLocation } from "react-router-dom";
import { generatedTypeObj } from "app/_pages/UserManagement/Employee/Constant";
import { FaHourglassEnd } from "react-icons/fa";
import moment from "moment";
import { BsStopwatch } from "react-icons/bs";

const TrainingAll = ({
  match: {
    params: { siteId },
  },
}) => {
  const [trainings, setTrainings] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const downloadPdf = async (certificateFile) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByExistURL(
      URL_CONFIG.IMG_URL + certificateFile,
      `training-certificate-${new Date().toISOString()}.pdf`
    );

    // downloadFileByURL(
    //   URL_CONFIG.DEV_URL +
    //     "global-configuration/ehs-module/download-training-certificate/" +
    //     id,
    //   `training-certificate-${new Date().toISOString()}.pdf`
    // );
  };

  const onReset = () => setFilterForm({ batchName: "", traineeDesignation: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "traineeTypeView") {
        prev.traineeId = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const [sort, setSort] = useState({ order: "asc", dataField: "" });

  const tableContainerRef = useRef(null);

  const onTableChange = (actionType, { sortField: dataField, sortOrder: order }) => {
    if (actionType !== "sort") return;

    setSort({ dataField, order });
    setTableVFLList((prev) => {
      const newRows = [...prev].sort((a, b) => {
        if (order === "asc") return a[dataField] > b[dataField] ? -1 : 1;
        else return a[dataField] < b[dataField] ? -1 : 1;
      });

      return newRows;
    });
  };

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeIdNo",
        text: "ID",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (index, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      // {
      //   dataField: "trainingTypeView",
      //   text: "Training Type",
      //   sort: true,
      // },
      {
        dataField: "trainingDesignationName",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "trainingEligibility",
        text: "Training Eligibility",
        sort: true,
        formatter: (index, row) => {
          return row?.trainingEligibility ? "Yes" : "No";
        },
      },
      {
        dataField: "lastDoneDate",
        text: "Last Done",
        sort: true,
        formatter: (id, row) => {
          return row?.lastDoneDate ? DDMMYYYYFormat(row?.lastDoneDate) : "NA";
        },
      },
      {
        text: "Certificate No.",
        dataField: "trainingCertificateNo",
        sort: true,
        formatter: (id, row) => {
          let isCertificate = false;
          let certificateFile = "";
          if (
            // row?.medicalTestType === MEDICAL_TYPE.ime &&
            row?.trainingCertificateId &&
            row?.trainingUpdateBy === generatedTypeObj.manual
          ) {
            isCertificate = true;
            certificateFile = row?.trainingfile && row?.trainingfile?.document_name;
          }
          return (
            <div className="actionIconsGroup">
              <span>{row?.trainingCertificateNo || "NA"}</span>
              {isCertificate && isUserVTO() && (
                <CustomTooltip tooltip={"Certificate"}>
                  <span
                    onClick={() => downloadPdf(certificateFile)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              )}
            </div>
          );
        },
      },
      {
        dataField: "nextTrainingDueDate",
        text: "Next Due",
        sort: true,
        formatter: (id, row) => {
          return row?.nextTrainingDueDate ? (
            <span className="icons dateWthIcn">
              <span>{DDMMYYYYFormat(row?.nextTrainingDueDate)}</span>
              {moment().year() >= moment(row?.nextTrainingDueDate).year() ? (
                <>
                  {TRAINING_PROGRESS_CHECK?.includes(row?.trainingStatus) ? (
                    <FaHourglassEnd style={{ color: "#2bb0e5" }} />
                  ) : // ) : moment(row?.nextTrainingDueDate) < moment() ? (
                  row?.trainingStatus === TRAINING_STATUS.overDue ? (
                    <img
                      src="/assets/images/overDueImg.png"
                      alt="over-dueImg"
                      className="iconImg"
                    />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </span>
          ) : (
            <span className="icons dateWthIcn noDT">
              <span>NA</span>
              {/* {TRAINING_PROGRESS_CHECK?.includes(row?.trainingStatus) ? (
                <FaHourglassEnd style={{ color: "#2bb0e5" }} />
              ) : // ) : moment(row?.nextTrainingDueDate) < moment() ? (
              row?.trainingStatus === TRAINING_STATUS.overDue ? (
                <img
                  src="/assets/images/overDueImg.png"
                  alt="over-dueImg"
                  className="iconImg"
                />
              ) : (
                ""
              )} */}
            </span>
          );
        },
      },
      // {
      //   dataField: "certificateId",
      //   text: "Certificate",
      //   sort: true,
      //   formatter: (id, row) => {
      //     return (
      //       <div className="actionIconsGroup">
      //         {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() ? (
      //           <CustomTooltip tooltip={"Certificate"}>
      //             <span
      //               onClick={() => downloadPdf(row?.id)}
      //               className="icons text-cyanBlue"
      //             >
      //               <FiInfo style={{ color: "rgb(21 239 21)" }} />
      //             </span>
      //           </CustomTooltip>
      //         ) : (
      //           "In Progress"
      //         )}
      //       </div>
      //     );
      //   },
      // },
    ];

    return column;
  }, [siteId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllTrainingAssignersData(
          siteId ? `filter[siteId]=${siteId}` : ""
        );

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setTrainings(
          Array.isArray(response?.data)
            ? response?.data.map((data) => ({
                ...data,
                locationName: data?.ehsSite ? data?.ehsSite?.name : "",
              }))
            : []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, [siteId]);

  useEffect(() => {
    setTableVFLList(
      trainings?.filter?.((data) => {
        let flag = true;
        if (filterForm?.traineeTypeView === "All") flag = true;

        if (flag) {
          for (const key in filterForm) {
            if (
              (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
              !filterForm[key]
            )
              continue;
            if (
              key !== "traineeDesignation" &&
              key !== "batchName" &&
              data[key] !== filterForm[key]
            )
              return (flag = false);
            else if (
              (key === "traineeDesignation" || key === "batchName") &&
              !data[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
            )
              return (flag = false);
          }

          return (flag = true);
        }

        // if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, trainings]);

  const finalAllTrainingFilter = useMemo(
    () => trainingStatusFilterFields.filter((d) => allTrainingFilter.includes(d.name)),
    []
  );

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingStatusFilters
        fields={finalAllTrainingFilter}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "Training Status" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="p-2">
        <div className="card p-3 mt-3" ref={tableContainerRef}>
          <div className="simple-card-title">
            <h3 className="text-capitalize mb-1">Training Status</h3>
            <FilterBtn setShowFilter={setShowFilter} />

            <BackBtn url="/health-safety-and-environment/training-management" />
          </div>
          <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-2">
            <div className="hseMenuLinks card">
              <Link
                to={"/health-safety-and-environment/training-management/status"}
                className={`pointer${
                  location?.pathname.split("/")?.includes("status") ? " active" : ""
                }`}
              >
                Training Data - Workflow Generated
              </Link>
              <Link
                to={"/health-safety-and-environment/training-management/all-training"}
                className={`pointer${
                  location?.pathname.split("/")?.includes("all-training") ? " active" : ""
                }`}
              >
                Training Data - All
              </Link>
            </div>
          </div>
          {!loading ? (
            <SearchBootstrapTable
              searchKey={"allTrainingDesktopSearch"}
              data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              columns={sortableColumn}
              onTableChange={onTableChange}
              sort={sort}
              remote={{
                sort: true,
              }}
              tableBeforeSearch={tableToolbarBeforeView}
              tableKey={"allTraining"}
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
      </div>
    </>
  );
};

export default TrainingAll;
